import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, getInlineLoader } from "../Helpers";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_DEBTS,
  STR_CHARITY,
  STR_EXPENSES,
  STR_INCOME,
  STR_INSURANCE,
  STR_INVESTMENTS,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_SAVINGS,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME,
  STR_VIEW_MORE,
  STR_MESSAGES,
  STR_CREATE_NEW,
  STR_NO_RECORD
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import OneMessage from '../ones/OneMessage';

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      appContext.getAllMessages(),
    ])
    setReady(true);
  }



  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
          paddingBottom: "20px"
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-12">
              <h6 className="mSectionTitle">
                {STR_MESSAGES[appContext.language]}
              </h6>

              <div className="text-end">
                <button
                  className="btn btn-sm btn-rounded btn-padded bg-secondary"
                  onClick={() => {
                    appContext.navTo({
                      item: 'view',
                      subItem: 'create-message',
                    })
                  }}
                >
                  {STR_CREATE_NEW[appContext.language]}
                </button>
              </div>
              <hr/>
            </div>

            <div className="col-md-12">
              {
                (appContext.allMessages && appContext.allMessages.length > 0) ?
                appContext.allMessages.map((item, i) => {
                  return (
                    <OneMessage data={item} key={i}/>
                  )
                })
                :
                <h6
                  className=""
                  style={{
                    fontSize: "14px"
                  }}
                >
                  {STR_NO_RECORD[appContext.language]}
                </h6>
              }
            </div>

          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}